<ng-container [ngTemplateOutlet]="direction == 'down' ? arrowDown : arrowUp">
</ng-container>
<ng-template #arrowDown>
  <bizz-icon class="size-full" iconName="angle-down"></bizz-icon>
</ng-template>
<ng-template #arrowUp>
  <bizz-icon class="size-full" iconName="angle-up"></bizz-icon>
</ng-template>
